var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        title: _vm.$t("message.experience.unavailable_service_area_modal_title")
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function(ref) {
            var cancel = ref.cancel
            return [
              _c(
                "b-button",
                {
                  attrs: { variant: "secondary" },
                  on: {
                    click: function($event) {
                      return cancel()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("message.button.close")) +
                      "\n    "
                  )
                ]
              )
            ]
          }
        }
      ])
    },
    [
      _c("div", [
        _c("div", [
          _c("b", [_vm._v(_vm._s(_vm.$t("message.my_listings.province")))])
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "maininfo-list" },
          _vm._l(_vm.sortedProvinces, function(province) {
            return _c("li", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("multiLangName")(province)) +
                  "\n      "
              )
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v(_vm._s(_vm.$t("message.my_listings.district")))])
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "maininfo-list" },
          _vm._l(_vm.sortedDistricts, function(district) {
            return _c("li", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("multiLangName")(district)) +
                  "\n      "
              )
            ])
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e10f0a7", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e10f0a7","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/experience/components/UnavailableServiceAreaModal.vue
// module id = 1723
// module chunks = 0